module.exports = __webpack_public_path__ + "img/zixunshenqing.e0f35d0e.svg";